import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import regulamin from "@/data/legal/regulamin.json";
import prywatnosc from "@/data/legal/polityka-prywatnosci.json";
import cookies from "@/data/legal/cookies.json";

const DOCS = { regulamin, "polityka-prywatnosci": prywatnosc, cookies };

const LEGAL_NAV = [
  { slug: "regulamin", label: "Regulamin" },
  { slug: "polityka-prywatnosci", label: "Polityka prywatności" },
  { slug: "cookies", label: "Polityka cookies" },
];

export default function LegalPage({ docKey }) {
  const doc = DOCS[docKey];
  return (
    <div className="min-h-screen bg-brand-bg px-4 py-10">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8 flex items-center justify-between">
          <Link to="/" aria-label="Promptivo — strona główna">
            <Logo height={26} />
          </Link>
          <Link to="/pomoc" className="inline-flex items-center gap-1.5 text-sm text-brand-sec hover:text-brand-text">
            <ArrowLeft size={15} /> Centrum pomocy
          </Link>
        </div>

        <nav className="mb-8 flex flex-wrap gap-2" aria-label="Dokumenty prawne">
          {LEGAL_NAV.map((n) => (
            <Link
              key={n.slug}
              to={`/${n.slug}`}
              data-testid={`legal-nav-${n.slug}`}
              className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
                n.slug === docKey
                  ? "border-brand-accent bg-brand-accent/10 text-brand-accent"
                  : "border-brand-line text-brand-sec hover:border-brand-accent/50 hover:text-brand-text"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <article data-testid={`legal-page-${docKey}`} className="rounded-panel border border-brand-line bg-brand-surface p-6 sm:p-9">
          <p className="mb-2 inline-block rounded-full bg-brand-elevated px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-accent">
            Wersja robocza — do weryfikacji prawnej
          </p>
          <h1 className="font-display text-3xl font-semibold text-brand-text">{doc.title}</h1>
          <div
            className="legal-prose mt-6"
            dangerouslySetInnerHTML={{ __html: doc.html }}
          />
        </article>
      </div>
    </div>
  );
}
